export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const EMAIL_REGEX_DOT_REQUIRED =
  // tslint:disable-next-line:max-line-length
  /^(([().!#$%&'*+\/=?^_`{|}~\u00BF-\u1FFF\u2C00-\uD7FF\w-]+[,\n#\s$&:\n\t]+){2,}){0,}(?:<){0}[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.)+[a-zA-Z0-9]{2,}(?:>){0,1}$/;

// tslint:disable-next-line
export const URL_REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9\u00C0-\u017F]+)*\.[a-zA-Z0-9]+(:[0-9]+)?(\/.*)?$/;
// tslint:disable-next-line
export const URL_WITH_ATTRIBUTES_REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(({{[a-zA-Z0-9 ]+}})+|([a-zA-Z0-9]+))([-.]([a-zA-Z0-9\u00C0-\u017F]+|({{[a-zA-Z0-9 ]+}})+)+)*\.(({{[a-zA-Z0-9 ]+}})+|([a-zA-Z0-9]+))+(:[0-9]+)?([\/?].*)?$/;

export const PHONE_MATCH_REGEX = /\+?\(?\d*\)? ?\(?\d+\)?\d*([\s./-]?\d{2,})+/;

export const EMAIL_MATCH_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/;
